module.exports = __webpack_public_path__ + "img/12_DSC8058.c9dd61df.jpg";